const it = {
  nav_timeline: "Cronologia",
  nav_invest: "Investire",
  nav_technology: "Tecnologia",
  nav_roadmap: "Roadmap",
  nav_join: "Unisciti",
  hero_badge: "Allineato con la Roadmap della Missione Artemis",
  hero_title_1: "Investire nel",
  hero_title_2: "Futuro della Civiltà",
  hero_title_3: "Lunare",
  hero_subtitle: "ARTEMIDA è un'iniziativa privata che supporta la prossima generazione di infrastrutture lunari allineata con la roadmap globale della missione Artemis.",
  hero_cta_join: "Unisciti agli Investitori Iniziali",
  hero_cta_whitepaper: "Scarica il Whitepaper",
  hero_stat_1_label: "Traguardo della Missione",
  hero_stat_2_label: "Fasi di Sviluppo",
  hero_stat_3_label: "Scala Energetica Orbitale",
  hero_scroll: "Scorri",
  timeline_badge: "Fasi della Missione",
  timeline_title: "Cronologia del Progetto",
  timeline_subtitle: "Quattro fasi strategiche verso un'economia lunare permanente e una rete energetica orbitale.",
  phase1_name: "ARTEMIDA II",
  phase1_year: "Completata 2026",
  phase1_title: "Missione Orbitale Lunare con Equipaggio",
  phase1_desc: "Traguardo della missione orbitale lunare con equipaggio raggiunto. Primo avvicinamento con equipaggio all'orbita lunare nell'ambito dell'iniziativa privata ARTEMIDA.",
  phase2_name: "ARTEMIDA III",
  phase2_year: "2027",
  phase2_title: "Logistica Superficie Lunare",
  phase2_desc: "Fase preparatoria per l'infrastruttura logistica della superficie lunare. Dispiegamento di sistemi cargo autonomi e beacon di navigazione superficiale.",
  phase3_name: "ARTEMIDA IV",
  phase3_year: "2028",
  phase3_title: "Presenza Lunare Permanente",
  phase3_desc: "Inizio della presenza lunare permanente e dei sistemi di supporto al dispiegamento della base. Costruzione di habitat modulari con supporto vitale e generazione di energia.",
  phase4_name: "Rete Solare Orbitale",
  phase4_year: "2030+",
  phase4_title: "Infrastruttura Solare Spaziale",
  phase4_desc: "Sviluppo di infrastrutture solari spaziali progettate per supportare il finanziamento a lungo termine dell'economia lunare.",
  status_completed: "Completata",
  status_active: "In Corso",
  status_upcoming: "In Arrivo",
  invest_badge: "Caso di Investimento",
  invest_title_1: "Perché Investire in",
  invest_subtitle: "L'economia lunare non è un concetto lontano — si sta costruendo ora. ARTEMIDA offre un raro punto di ingresso nello strato infrastrutturale dell'espansione dell'umanità oltre la Terra.",
  invest_global: "Allineamento Globale con Artemis",
  invest_global_sub: "In partnership con agenzie spaziali internazionali e operatori privati",
  reason1_title: "Supporto all'Infrastruttura Lunare",
  reason1_desc: "Finanzia direttamente la spina dorsale fisica della prossima frontiera dell'umanità — dalla logistica superficiale ai sistemi di relay orbitali.",
  reason2_title: "Crescita dell'Economia Spaziale",
  reason2_desc: "Partecipa al settore in più rapida crescita dell'economia globale. Si prevede che l'industria spaziale superi $1 trilione entro il 2040.",
  reason3_title: "Accesso Anticipato all'Ecosistema",
  reason3_desc: "Ottieni accesso anticipato al futuro ecosistema della rete energetica orbitale — posizionando il tuo portafoglio all'intersezione tra energia pulita e infrastruttura spaziale.",
  reason4_title: "Posizionamento Aerospaziale Strategico",
  reason4_desc: "Assicurati un posizionamento strategico nell'innovazione aerospaziale di nuova generazione. ARTEMIDA collabora con istituzioni globali e aziende spaziali private.",
  funding_badge: "Struttura del Capitale",
  funding_title: "Strategia di Finanziamento",
  funding_subtitle: "L'iniziativa ARTEMIDA è allineata con futuri modelli di finanziamento aerospaziale su larga scala e partnership con istituzioni globali e aziende spaziali private.",
  funding_metric1_label: "Raccolta Target",
  funding_metric1_sub: "Serie A e B combinate",
  funding_metric2_label: "Partner Strategici",
  funding_metric2_sub: "Istituzioni globali",
  funding_metric3_label: "Allocazione Infrastrutturale",
  funding_metric3_sub: "Asset lunari diretti",
  funding_metric4_label: "Orizzonte dei Ricavi",
  funding_metric4_sub: "Vendite di energia orbitale",
  funding_alloc_title: "Modello di Allocazione del Capitale",
  funding_alloc1: "Infrastruttura Lunare",
  funding_alloc2: "Sviluppo Solare Orbitale",
  funding_alloc3: "Logistica e Operazioni",
  funding_alloc4: "R&S e Innovazione",
  funding_partners: "Partner e Collaboratori dell'Ecosistema",
  partner1: "Agenzie Spaziali",
  partner2: "Istituzioni Globali",
  partner3: "Aziende Spaziali Private",
  partner4: "Venture Capital",
  partner5: "Operatori Orbitali",
  partner6: "Partner Tecnologici",
  tech_badge: "Sistemi Principali",
  tech_title: "Visione Tecnologica",
  tech_subtitle: "Quattro pilastri dell'ecosistema tecnologico ARTEMIDA, progettati per l'economia lunare a lungo termine.",
  tech1_title: "Array Solari Spaziali",
  tech1_desc: "Massicci array fotovoltaici dispiegati in orbita geostazionaria, che catturano energia solare ininterrotta e la trasmettono tramite fasci a microonde.",
  tech1_s1: "99.9% disponibilità",
  tech1_s2: "Potenza in scala GW",
  tech1_s3: "Trasmissione a microonde",
  tech2_title: "Sistemi Logistici Orbitali",
  tech2_desc: "Veicoli di trasferimento orbitale autonomi e depositi di rifornimento che formano un'autostrada cislunar permanente per trasporti regolari.",
  tech2_s1: "Operazioni autonome",
  tech2_s2: "Veicoli riutilizzabili",
  tech2_s3: "Transito Terra-Luna 72h",
  tech3_title: "Infrastruttura di Supporto Lunare",
  tech3_desc: "Habitat pressurizzati modulari, sistemi di costruzione a base di regolite e veicoli di superficie autonomi che formano la base fisica di un insediamento lunare permanente.",
  tech3_s1: "Costruzione con regolite",
  tech3_s2: "Habitat modulari",
  tech3_s3: "Rover autonomi",
  tech4_title: "Framework dell'Economia Spaziale",
  tech4_desc: "Uno strato economico di nuova generazione che integra diritti sulle risorse tokenizzati, trading di energia orbitale e governance decentralizzata.",
  tech4_s1: "Asset tokenizzati",
  tech4_s2: "Trading energetico",
  tech4_s3: "Governance DAO",
  roadmap_badge: "Cronologia Strategica",
  roadmap_title: "Roadmap",
  roadmap_subtitle: "Un percorso chiaro dal traguardo orbitale all'economia lunare su larga scala — costruito su progressi verificati.",
  rm1_title: "Traguardo della Missione Orbitale Raggiunto",
  rm1_detail: "ARTEMIDA II completa con successo l'orbita lunare con equipaggio. Architettura della missione validata. Fiducia degli investitori assicurata.",
  rm2_title: "Fase Preparatoria della Missione Lunare",
  rm2_detail: "ARTEMIDA III inizia la preparazione della logistica superficiale. Sistemi cargo autonomi dispiegati. Rete di beacon stabilita.",
  rm3_title: "Fase di Espansione dell'Infrastruttura Lunare",
  rm3_detail: "ARTEMIDA IV avvia il dispiegamento permanente della base. Iniziano habitat modulari, sistemi di alimentazione e operazioni superficiali.",
  rm4_title: "Strategia di Scaling dell'Energia Solare Orbitale",
  rm4_detail: "Dispiegamento completo degli array solari spaziali. Inizia il trading di energia orbitale. L'economia lunare raggiunge la soglia di autosufficienza.",
  token_badge: "Token Economics",
  token_title: "Utilità del Token",
  token_subtitle: "Il token ARTEMIDA è la spina dorsale economica dell'ecosistema dell'infrastruttura lunare — alimentando accesso, governance e crescita.",
  token1_title: "Accesso ai Servizi dell'Ecosistema",
  token1_desc: "I detentori di token ottengono accesso prioritario ai servizi della piattaforma ARTEMIDA, feed di dati orbitali e diritti di utilizzo dell'infrastruttura lunare.",
  token2_title: "Partecipazione alla Governance",
  token2_desc: "Vota sulle decisioni chiave del progetto, incluse le priorità della missione, l'allocazione del capitale e le approvazioni delle partnership.",
  token3_title: "Strato di Finanziamento dell'Infrastruttura",
  token3_desc: "I token servono come strumento principale per finanziare progetti di infrastruttura lunare e orbitale, con rendimenti proporzionali legati alle performance degli asset.",
  token4_title: "Integrazione nell'Economia Spaziale",
  token4_desc: "Integrato senza soluzione di continuità nell'economia cislunar emergente — abilitando il trading energetico, i diritti sulle risorse e l'interoperabilità cross-platform.",
  token_supply: "Offerta totale: <strong>1.000.000.000 ARTM</strong> — distribuita tra finanziamento infrastrutturale, premi dell'ecosistema, vesting del team e tranche di vendita pubblica.",
  cta_badge: "Accesso Anticipato",
  cta_title_1: "Unisciti al Programma",
  cta_title_2: "Early Supporter di ARTEMIDA",
  cta_subtitle: "Assicurati il tuo posto nella prima ondata di investitori nell'infrastruttura lunare. Slot di accesso anticipato limitati.",
  form_join_title: "Unisciti agli Investitori Iniziali",
  form_first_name: "Nome",
  form_last_name: "Cognome",
  form_email: "Email",
  form_org: "Organizzazione",
  form_org_placeholder: "Fondo / Azienda",
  form_interest: "Interesse di Investimento",
  form_interest_placeholder: "Seleziona intervallo",
  form_message: "Messaggio (opzionale)",
  form_message_placeholder: "Raccontaci della tua tesi di investimento...",
  form_submit_join: "Candidati per l'Accesso Anticipato",
  form_submitting: "Invio in corso...",
  form_success_join_title: "Candidatura Ricevuta",
  form_success_join_sub: "Il nostro team ti contatterà entro 48 ore.",
  form_wp_title: "Scarica il Whitepaper",
  form_full_name: "Nome Completo",
  form_full_name_placeholder: "Il tuo nome completo",
  form_email_placeholder: "tua@email.com",
  form_role: "Ruolo",
  form_role_placeholder: "Seleziona il tuo ruolo",
  form_role_investor: "Investitore",
  form_role_analyst: "Analista / Ricercatore",
  form_role_media: "Media / Stampa",
  form_role_partner: "Potenziale Partner",
  form_role_other: "Altro",
  form_country: "Paese",
  form_country_placeholder: "Italia",
  form_wp_file: "ARTEMIDA Whitepaper v2.1",
  form_wp_file_sub: "48 pag. · PDF · 12.4 MB",
  form_submit_wp: "Richiedi il Whitepaper",
  form_success_wp_title: "Whitepaper Inviato",
  form_success_wp_sub: "Controlla la tua casella di posta per il whitepaper ARTEMIDA.",
  // Reviews
  reviews_badge: "Recensioni Clienti",
  reviews_title: "Cosa Dicono gli Investitori",
  reviews_subtitle: "Recensioni reali di clienti da diversi paesi che hanno ricevuto i loro pagamenti.",
  reviews_verified: "Verificato",
  reviews_stat1: "Clienti Soddisfatti",
  reviews_stat2: "Giorni al Pagamento",
  reviews_stat3: "Contratti Riusciti",

  // Calculator
  calc_badge: "Calcolatore di Profitto",
  calc_title: "Calcola il Tuo Profitto",
  calc_subtitle: "Seleziona un contratto o inserisci il tuo importo e scopri il pagamento esatto entro 3 giorni lavorativi.",
  calc_select_contract: "Seleziona Contratto",
  calc_custom_amount: "O Inserisci il Tuo Importo",
  calc_custom_placeholder: "Es. 45000",
  calc_custom_note: "Il rendimento è calcolato in base alle condizioni del contratto selezionato",
  calc_payout_label: "Pagamento in 3 Giorni Lavorativi",
  calc_payout_desc: "I fondi vengono trasferiti automaticamente al completamento del contratto",
  calc_your_investment: "Il Tuo Investimento",
  calc_yield_label: "rendimento",
  calc_initial: "Importo Iniziale",
  calc_profit: "Profitto",
  calc_total_payout: "Pagamento Totale",
  calc_days_note: "Pagamento entro 3 giorni lavorativi dall'attivazione del contratto",
  calc_stat_days: "Giorni Lavorativi",
  calc_stat_yield: "Rendimento",
  calc_stat_currency: "Valuta",
  calc_min_amount: "Importo minimo",
  livefeed_received: "ha ricevuto un pagamento",

  // Contracts Section
  contract_badge: "Condizioni di Investimento",
  contract_title_1: "Contratti",
  contract_title_2: "di Partecipazione Finanziaria",
  contract_subtitle: "ARTEMIDA offre contratti di investimento strutturati garantiti dal capitale operativo di SpaceX. Scegli il tuo livello e ricevi il pagamento entro 3 giorni lavorativi.",
  contract_collateral_title: "Struttura di Garanzia e Credito",
  contract_collateral_sub: "SpaceX gestisce la struttura di garanzia e il meccanismo di credito dell'iniziativa",
  contract_collateral_amount: "Importo Garanzia",
  contract_credit_amount: "Linea di Credito",
  contract_operator: "Operatore",
  contract_popular: "Popolare",
  contract_tier_entry: "Base",
  contract_tier_growth: "Crescita",
  contract_tier_premium: "Premium",
  contract_investment: "Investimento",
  contract_yield: "Rendimento",
  contract_return: "Profitto",
  contract_total: "Totale Pagamento",
  contract_payout: "Termine Pagamento",
  contract_days: "giorni lavorativi",
  contract_select: "Seleziona Contratto",
  contract_disclaimer: "Tutti i contratti sono strumenti di investimento concettuali nell'ambito dell'iniziativa ARTEMIDA. L'investimento nell'infrastruttura spaziale comporta rischi significativi. I risultati passati non garantiscono rendimenti futuri.",
  contract_modal_title: "Dettagli del Contratto",
  contract_modal_desc: "Per partecipare a questo contratto di investimento, contatta il nostro team tramite il modulo per i primi investitori qui sotto.",
  contract_modal_note: "Tutti i contratti sono soggetti a verifica dell'identità e conformità alla legge applicabile.",
  contract_modal_close: "Capito",

  // SpaceX Section
  spx_badge: "Allineamento Strategico",
  spx_title_1: "Allineato con la Visione di",
  spx_title_2: "SpaceX & Elon Musk",
  spx_subtitle: "ARTEMIDA è direttamente posizionata nella strategia solare orbitale di SpaceX. Elon Musk ha annunciato un obiettivo di 100 gigawatt di energia solare orbitale entro 30 mesi — ARTEMIDA è lo strato infrastrutturale che supporterà questa rivoluzione.",
  spx_stat1_label: "Obiettivo SpaceX",
  spx_stat1_sub: "Produzione annuale di energia solare orbitale entro fine 2028",
  spx_stat2_label: "Efficienza Superiore in Orbita",
  spx_stat2_sub: "Le stazioni solari spaziali producono 5× più energia rispetto a quelle terrestri",
  spx_stat3_label: "Mesi al Dispiegamento",
  spx_stat3_sub: "Musk: il solare orbitale diventerà il metodo energetico più conveniente entro 30 mesi",
  spx_stat4_label: "Disponibilità Orbitale",
  spx_stat4_sub: "Niente notte, niente nuvole — cattura continua di energia solare 24/7",
  spx_quote: "Entro 30 mesi, l'energia solare spaziale diventerà il metodo di produzione energetica più conveniente. Starship può consegnare 300–500 GW di satelliti solari in orbita ogni anno.",
  spx_intro: "SpaceX e Tesla stanno lavorando per produrre 100 GW di celle solari all'anno. Starship, con 200 tonnellate per volo, dispiegherà massicci array solari orbitali — alimentando direttamente l'infrastruttura lunare di ARTEMIDA e i data center AI sulla Terra.",
  spx_fact1_title: "Starship — Il Motore del Dispiegamento",
  spx_fact1_desc: "Starship trasporta 200 tonnellate per volo e può consegnare 300–500 GW di satelliti solari in orbita ogni anno. I costi di lancio scendono a $100–200/kg, rendendo finanziariamente praticabili stazioni solari orbitali da 10 GW.",
  spx_fact2_title: "×5 Efficienza: La Fisica dell'Energia Orbitale",
  spx_fact2_desc: "In orbita, i pannelli solari catturano energia per il 99% del tempo — niente notte, niente nuvole, niente diffusione atmosferica. L'intensità solare è del 40% superiore e la resa energetica annuale è fino a 13× maggiore rispetto a un impianto terrestre.",
  spx_fact3_title: "100 GW entro Fine 2028",
  spx_fact3_sub: "Musk ha annunciato al WEF 2026 che SpaceX e Tesla stanno lavorando indipendentemente verso 100 GW di capacità produttiva annuale di celle solari negli USA.",
  spx_fact3_desc: "Musk ha annunciato al World Economic Forum 2026 che SpaceX e Tesla stanno lavorando indipendentemente per costruire 100 GW di capacità produttiva annuale di celle solari negli USA — per alimentare AI e infrastruttura lunare.",
  spx_compare_title: "Efficienza: Solare Terrestre vs. Solare Orbitale",
  spx_compare_ground: "Stazione solare terrestre",
  spx_compare_orbit: "Stazione solare orbitale (SpaceX)",
  spx_compare_note: "Le stazioni solari orbitali generano fino a 13× più energia annualmente rispetto a un impianto terrestre identico grazie all'esposizione continua e all'assenza di diffusione atmosferica. Costo previsto: ~3.8¢/kWh a maturità.",

  footer_tagline: "Innovazione Spaziale | Infrastruttura Lunare | Futuro dell'Energia Orbitale",
  footer_rights: "© 2026 ARTEMIDA Initiative. Tutti i diritti riservati.",
  footer_disclaimer: "Questo sito è solo a scopo informativo e non costituisce consulenza finanziaria o un'offerta di vendita di titoli. L'investimento nell'infrastruttura spaziale comporta rischi significativi.",
};

export default it;
